import React from 'react';
import { useFaqData } from './useFAQData';
import st from './style.module.scss';

const FaqHeader = ({ type }) => {
  const { getHeaderData } = useFaqData();
  const HEADER_DATA = getHeaderData();
  const { header, description } = HEADER_DATA[type];
  return (
    <div className={st.faqHeaderContainer}>
      <p className={st.faqHeaderTitle}>{header}</p>
      <p className={st.faqHeaderDescription}>{description}</p>
    </div>
  );
};

export default FaqHeader;
